<div class="flex flex-col h-full bg-shui-base-3" data-testid="details-refer-out-dialog">
    <!-- Header (fixed) -->
    <header
        class="flex items-center justify-between border-solid border-0 border-b-2 border-b-shui-base-4 p-4 flex-shrink-0"
    >
        <span class="text-base text-shui-text-strong font-semibold">
            {{ 'request.requestDetail.external-referral-dialog.title' | translate }}
        </span>
        <sh-button (click)="close()" icon="cancel" layout="normal" color="secondary" size="s"></sh-button>
    </header>

    <!-- Scrollable content -->
    <div class="flex-1 overflow-y-auto p-4">
        <div class="flex flex-col gap-4">
            <!-- Description -->
            <p class="text-sm text-shui-text-subtle m-0">
                {{ 'request.requestDetail.external-referral-dialog.description' | translate }}
            </p>

            <hr class="border-0 border-t border-shui-base-4 m-0" />

            <form [formGroup]="formGroup" class="flex flex-col gap-4">
                <!-- Referral name -->
                <sh-input-text
                    data-testid="details-refer-out-dialog-input-referral-name"
                    formControlName="name"
                    [label]="'request.requestDetail.external-referral-dialog.form.name' | translate"
                    [error]="formGroup.controls.name.touched && formGroup.controls.name.invalid"
                    [attr.error-message]="
                        formGroup.controls.name.hasError('required') && formGroup.controls.name.touched
                            ? ('request.requestDetail.external-referral-dialog.form.name-required' | translate)
                            : null
                    "
                    mandatory
                ></sh-input-text>

                <!-- External email -->
                <sh-input-text
                    data-testid="details-refer-out-dialog-input-external-email"
                    formControlName="referredOutEmail"
                    [label]="'request.requestDetail.external-referral-dialog.form.external-assignee-email' | translate"
                    [error]="formGroup.controls.referredOutEmail.touched && formGroup.controls.referredOutEmail.invalid"
                    [attr.error-message]="
                        formGroup.controls.referredOutEmail.hasError('required') &&
                        formGroup.controls.referredOutEmail.touched
                            ? ('request.requestDetail.external-referral-dialog.form.external-assignee-email-required'
                              | translate)
                            : formGroup.controls.referredOutEmail.hasError('email') &&
                                formGroup.controls.referredOutEmail.touched
                              ? ('request.requestDetail.external-referral-dialog.form.external-assignee-email-required'
                                | translate)
                              : null
                    "
                    mandatory
                ></sh-input-text>

                <!-- Internal message toggle -->
                @if (data.canMarkCommentAsInternal) {
                    <sh-checkbox
                        formControlName="markAsInternal"
                        [label]="'request.requestDetail.comments.internal-message' | translate"
                    ></sh-checkbox>
                }

                <!-- Description / comment -->
                <sh-editor
                    data-testid="details-refer-out-dialog-textarea-description"
                    formControlName="description"
                    [placeholder]="
                        'request.requestDetail.external-referral-dialog.form.task-description-optional' | translate
                    "
                    [attr.tooltip]="
                        data.isReferredOutAfterSubmission
                            ? ('request.requestDetail.external-referral-dialog.form.task-description-tooltip'
                              | translate)
                            : null
                    "
                    class="w-full"
                ></sh-editor>

                <!-- File upload -->
                <sh-file-input formControlName="attachments" [multiple]="true" class="w-full"></sh-file-input>
            </form>
        </div>
    </div>

    <!-- Footer (fixed) -->
    <div
        class="flex justify-between items-center gap-2 p-4 border-solid border-0 border-t-2 border-t-shui-base-4 flex-shrink-0"
    >
        <sh-button
            [label]="'request.requestDetail.external-referral-dialog.cancel' | translate"
            layout="compact"
            color="secondary"
            size="max-content"
            (click)="close()"
        ></sh-button>
        <sh-button
            data-testid="details-refer-out-dialog-button-confirm"
            [label]="'request.requestDetail.external-referral-dialog.confirm' | translate"
            layout="compact"
            size="max-content"
            [disabled]="formGroup.invalid"
            [attr.tooltip]="
                formGroup.invalid
                    ? ('request.requestDetail.external-referral-dialog.form-invalid-tooltip' | translate)
                    : null
            "
            (click)="confirm()"
        ></sh-button>
    </div>
</div>
